<template>
  <v-container>
    <v-row no-gutters class="flex-column tableGroup">
      <v-col cols="12" v-for="(item, idx) in packages" :key="idx">
        <div class="columnGroup" :class="(item.name == hasEnd) ? 'hasEnd' : ''">
          <div class="pt-4 font-weight-bold">{{item.name}}</div>
          <div class="py-1 d-flex justify-center">
            <span class="text-h4 pr-1 font-weight-bold">{{item.priceMonth}}</span>
            <translate class="subText"
            :style="(item.name == hasEnd) ? 'display: none;' : 'display: block;'"
            >$ / month</translate>
          </div>
          <p class="subText mb-3"
          :style="(item.name == hasEnd) ? 'display: none;' : 'display: block;'"
          >{{item.priceYear}}<translate>$ / year</translate> {{item.note}}</p>
          <div
            class="pa-2 text-center white text-no-wrap rounded-t-xl
            columnGroup__border"
            :style="(item.name == hasEnd) ? 'display: none;' : 'display: block;'"
          >
            <a
              target="_blank"
              :href="'https://bestgolfcourse.org/template/' + item.value.replace('Pack','')"
            >
              <translate>See the sample</translate>
            </a>
          </div>
        </div>
        <template class="body">
          <v-row no-gutters class="flex-column mb-3">
            <v-col cols="12" v-for="(template, index) in item.check" :key="index">
              <div class="text-center pa-2" style="background: #F2F2F2;">
                <div v-if="template.text.topic" class="wrapper font-weight-bold">
                  <div class="mb-1">{{template.text.topic}}</div>
                  <div class="text-caption font-weight-light">{{template.text.sub}}</div>
                </div>
                <div v-else-if="template.text.length == 2" class="wrapper font-weight-bold">
                  <div v-for="text in template.text" :key="text">
                    {{text}}
                  </div>
                </div>
                <div v-else class="wrapper font-weight-bold">
                  {{template.text}}
                </div>
              </div>
              <div class="text-center py-2">
                <div v-if="template.type == 'text'" class="primary--text">
                  {{template.value}}
                </div>
                <div v-else>
                  <v-icon v-if="template.value" class="fal fa-check primary--text"></v-icon>
                  <v-icon v-else class="fal fa-xmark primary--text"></v-icon>
                </div>
              </div>
            </v-col>
          </v-row>
        </template>
        <div class="text-center mb-6">
          <v-btn rounded class="btnContact" @click="$emit('openDialog', item)">
            <translate>Contact us</translate>
            <icon name="icon-sent" width="25" height="25" class="ml-3"/>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "TableSellingMobile",
  props: {
    headers: {},
    databody: {}
  },
  components: {},
  data() {
    return {
      hasEnd: 'Hole-in-One Pack',
      packages: [
        {
          value: 'parPack',
          name: this.$gettext('Par Pack'),
          priceMonth: this.$gettext('49'),
          priceYear: this.$gettext('539'),
          note: this.$gettext('(1 month free)'),
          check: [
            { text: this.$gettext('Layout'), value: false},
            { text: this.$gettext('About'), value: true},
            { text: this.$gettext('Golf courses'), value: true},
            { text: this.$gettext('Rates/fees'), value: true},
            { text: this.$gettext('Facilities'), value: true},
            { text: this.$gettext('Contact Form'), value: false},
            { text: this.$gettext('Promotions/Packages'), value: false},
            { text: this.$gettext('Attraction around the Golf '), value: false},
            { text: this.$gettext('Booking Tee-off Form '), value: false},
            { text: this.$gettext('Service presentation page '), value: false},
            { text: this.$gettext('Presentation hole by hole with pictures'), value: false },
            { text: [this.$gettext('Extra fees for designing the 2D holes: 25 Usd/hole'), this.$gettext('Extra fees for designing the 3D Holes: 70 Usd/hole')], value: false},
            { text: {
              topic: 'Get your own App IOS and Android: 20 Usd/month',
              sub:'(+ 3rd parties extra fees for Apple Account and Google Play account)'},
              value : false
            },
            { text: this.$gettext('Languages'), value: 1, type: 'text'},
            { text: this.$gettext('Hosting included'), value: true},
            { text: this.$gettext('BGC Ads “Push golf club”'), value: this.$gettext('100 000 display. in your country'), type: 'text'},
          ]
        },
        {
          value: 'birdiePack',
          name: this.$gettext('Birdie Pack'),
          priceMonth: this.$gettext('69'),
          priceYear: this.$gettext('759'),
          note: this.$gettext('(1 month free)'),
          check: [
            { text: this.$gettext('Layout'), value: false},
            { text: this.$gettext('About'), value: true},
            { text: this.$gettext('Golf courses'), value: true},
            { text: this.$gettext('Rates/fees'), value: true},
            { text: this.$gettext('Facilities'), value: true},
            { text: this.$gettext('Contact Form'), value: true},
            { text: this.$gettext('Promotions/Packages'), value: true},
            { text: this.$gettext('Attraction around the Golf '), value: true},
            { text: this.$gettext('Booking Tee-off Form '), value: true},
            { text: this.$gettext('Service presentation page '), value: false},
            { text: this.$gettext('Presentation hole by hole with pictures'), value: false},
            { text: [this.$gettext('Extra fees for designing the 2D holes: 25 Usd/hole'), this.$gettext('Extra fees for designing the 3D Holes: 70 Usd/hole')], value: false},
            { text: {
              topic: 'Get your own App IOS and Android: 20 Usd/month',
              sub:'(+ 3rd parties extra fees for Apple Account and Google Play account)'},
              value : false
            },
            { text: this.$gettext('Languages'), value: 2, type: 'text'},
            { text: this.$gettext('Hosting included'), value: true},
            { text: this.$gettext('SEO optimization and Google Analytics'), value: true},
            { text: this.$gettext('BGC Ads “Push golf club”'), value: this.$gettext('300 000 display. in your Area'), type: 'text'},
          ]
        },
        {
          value: 'eaglePack',
          name: this.$gettext('Eagle Pack'),
          priceMonth: this.$gettext('89'),
          priceYear: this.$gettext('979'),
          note: this.$gettext('(1 month free)'),
          check: [
            { text: this.$gettext('Layout'), value: false},
            { text: this.$gettext('About'), value: true},
            { text: this.$gettext('Golf courses'), value: true},
            { text: this.$gettext('Rates/fees'), value: true},
            { text: this.$gettext('Facilities'), value: true},
            { text: this.$gettext('Contact Form'), value: true},
            { text: this.$gettext('Promotions/Packages'), value: true},
            { text: this.$gettext('Attraction around the Golf '), value: true},
            { text: this.$gettext('Booking Tee-off Form '), value: true},
            { text: this.$gettext('Service presentation page '), value: true},
            { text: this.$gettext('Presentation hole by hole with pictures'), value: true},
            { text: [this.$gettext('Extra fees for designing the 2D holes: 25 Usd/hole'), this.$gettext('Extra fees for designing the 3D Holes: 70 Usd/hole')], value: true},
            { text: {
              topic: 'Get your own App IOS and Android: 20 Usd/month',
              sub:'(+ 3rd parties extra fees for Apple Account and Google Play account)'},
              value : true
            },
            { text: this.$gettext('Languages'), value: 5, type: 'text'},
            { text: this.$gettext('Hosting included'), value: true},
            { text: this.$gettext('SEO optimization and Google Analytics'), value: true},
            { text: this.$gettext('BGC Ads “Push golf club”'), value: this.$gettext('600 000 display. in 03 Area'), type: 'text'},
          ]
        },
        {
          value: 'hole-in-onePack',
          name: this.$gettext('Hole-in-One Pack'),
          priceMonth: this.$gettext('Tailored'),
          note: this.$gettext('(1 month free)'),
          check: [
            { text: this.$gettext('Layout'), value: false},
            { text: this.$gettext('About'), value: true},
            { text: this.$gettext('Golf courses'), value: true},
            { text: this.$gettext('Rates/fees'), value: true},
            { text: this.$gettext('Facilities'), value: true},
            { text: this.$gettext('Contact Form'), value: true},
            { text: this.$gettext('Promotions/Packages'), value: true},
            { text: this.$gettext('Attraction around the Golf '), value: true},
            { text: this.$gettext('Booking Tee-off Form '), value: true},
            { text: this.$gettext('Service presentation page '), value: true},
            { text: this.$gettext('Presentation hole by hole with pictures'), value: true},
            { text: [this.$gettext('Extra fees for designing the 2D holes: 25 Usd/hole'), this.$gettext('Extra fees for designing the 3D Holes: 70 Usd/hole')], value: true},
            { text: {
              topic: 'Get your own App IOS and Android: 20 Usd/month',
              sub:'(+ 3rd parties extra fees for Apple Account and Google Play account)'},
              value : true
            },
            { text: this.$gettext('Languages'), value: this.$gettext('Tailored'), type: 'text'},
            { text: this.$gettext('Hosting included'), value: true},
            { text: this.$gettext('SEO optimization and Google Analytics'), value: true},
            { text: this.$gettext('BGC Ads “Push golf club”'), value: this.$gettext('Tailored'), type: 'text'},
          ]
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {},
  watch: {}
};
</script>
<style>

</style>
